<div>
  <div>
    <div>
      <div class="container text-container">
        <div class="row">
          <div style="text-align: center" *ngIf="this.idBeneficio === 24">
            <button (click)="toggleGallery()" class="button-benefit">Ver imágenes cabañas</button>
            <br><br>
          </div>
          <div class="texto" [innerHTML]="detail">
            
          </div>
        </div>
      </div>

      <div class="evaluate-container">
        <div class="subtitle">
          <span class="copec-rg-20">Valoraciones</span>
        </div>

        <div>
          <div class="row container-footer">
            <div class="col-sm-12 col-md container-box">
              <div *ngIf="selectedVote === false">
                <div  class="box copec-rg-16">¿Qué nota le pondrías a este beneficio?</div>
                <section class="starts">
                  <i *ngFor="let s of star" 
                  class='fa-solid fa-star valoration' 
                  [ngClass]="{
                    'active':s.valor <= rating, 
                    'mouseOver' : s.valor <= mouseOver && validador
                    }" 
                    value = "s.valor" 
                    (click)="selectStart(s.valor)" 
                    (mouseover)="selectStarMouse(s.valor)" 
                    (focus)="selectStarMouse(s.valor)"
                    (mouseout)="notselecStar()"
                    (blur)="notselecStar()"></i>  
                </section>
              </div>
              <div *ngIf="selectedVote">
                <div class="box copec-rg-20">{{messageVote}}</div>
                 <div class="starts">
                  <i *ngFor="let s of arrStar" 
                     class = 'fa-solid fa-star valoration1'
                      [ngClass]="{'active':s <= rating}"      
                    ></i>
              </div>
            </div>
          </div>
            <div class="col-sm-12 col-md container-box">
              <div>
                <div class="box copec-rg-16">Promedio</div>
                <div class="icon">
                  <i class="fa-solid fa-star promedio"></i>
                  <span><b>{{averageOficial()}}</b></span>
                </div>
                <span class="icon" *ngIf="rating === 0 ">{{totalVotes}} valoraciones</span>
                <span class="icon" *ngIf="rating !== 0">{{totalVotes + 1}} valoraciones</span>
              </div>
            </div>
            <div class="col-sm-12 col-md container-box">
              <div>
                <div class="box copec-rg-16">Detalle</div>
                <div class="containerDetails">
                  <div class="box-details" *ngFor="let s of star">
                    <i class="fa-solid fa-star detalleStar">{{s.valor}}</i>
                    <div class="segundoProgress">
                      <div class="contenidoProgress" [style.width.%]= percentage(s.numberVotes,s.valor) ></div>
                    </div>
                    <p id= s.valor *ngIf="s.valor === rating" > ({{s.numberVotes + 1}})  </p>
                    <p id= s.valor *ngIf="s.valor !== rating " > ({{s.numberVotes}})  </p>
                  </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showGallery">
  <div class="modal-gallery-content">
    <span class="close-main" (click)="toggleGallery()">&times;</span>
    <h2>Galería de imágenes {{ title }}</h2>

    <div class="grid-3x3">
      <div class="grid-item" *ngFor="let img of images" (click)="zoomImage(img)">
        <img loading="lazy" alt="imageminimal" [src]="img.link" [alt]="img.descripcion">
        <div class="hover-info">Click para ampliar</div>
      </div>
    </div>
  </div>

  <div class="zoom-overlay" *ngIf="imageZoom" (click)="closeZoom()">
    <div class="zoom-card">
      <img loading="lazy" alt="imagezoom" [src]="imageZoom.link" class="img-expanded">
      <p>{{ imageZoom.descripcion }}</p>
      <button (click)="closeZoom()">Cerrar</button>
    </div>
  </div>
</div>